import * as InlineWorker from "inline-worker";
import { Middleware, Store } from "redux";
import {
  START_OFFLINE_RENDER,
  UPDATE_OFFLINE_RENDER_PROGRESS,
  UpdateOfflineRenderProgressAction
} from "../actions/actionTypes";
import { MainStore, PlaybackState } from "../store";
import { exportWavWorkerFunction } from "../util/exportWavWorkerFunction";
import { AudioMaster } from "./AudioMaster";

/**
 * Syncs state with WebAudio clock
 */
export function AudioMiddleWareOffline(
  audioMaster: AudioMaster,
  masterStore: Store<MainStore>
): Middleware {
  return store => next => action => {
    switch (action.type) {
      case START_OFFLINE_RENDER:
        const inMarkerTime = store.getState().project.markers.in.songTime;
        const outMarkerTime = store.getState().project.markers.out.songTime;
        const duration = outMarkerTime - inMarkerTime;

        const context = audioMaster.context as OfflineAudioContext;

        const progressInterval = setInterval(() => {
          const currentTime = audioMaster.context.currentTime - inMarkerTime;
          const progress = currentTime / duration;
          masterStore.dispatch<UpdateOfflineRenderProgressAction>({
            type: UPDATE_OFFLINE_RENDER_PROGRESS,
            progress
          });
        }, 100);

        store.getState().editorState.playbackState = PlaybackState.PLAYING;
        audioMaster.play(inMarkerTime);
        context.startRendering().then(renderedBuffer => {
          store.getState().editorState.playbackState = PlaybackState.PAUSED;
          audioMaster.pause();
          const worker = new InlineWorker(exportWavWorkerFunction);
          worker.postMessage({
            length: renderedBuffer.length,
            numberOfChannels: renderedBuffer.numberOfChannels,
            sampleRate: renderedBuffer.sampleRate,
            left: renderedBuffer.getChannelData(0),
            right: renderedBuffer.getChannelData(1)
          });
          clearInterval(progressInterval);

          worker.onmessage = e => {
            const blob = new window.Blob([new DataView(e.data)], {
              type: "audio/wav"
            });
            const state: MainStore = store.getState();
            const trackTitle = state.project.initialTrackData.title;
            const trackVariationTitle =
              state.project.initialTrackData.variationTitle;
            const customMixTitle = state.project.customMixInfo.title;
            const fileStem = (customMixTitle
              ? customMixTitle
              : `${trackTitle}${
                  trackVariationTitle ? "_" + trackVariationTitle : ""
                }`
            ).replace(/\s/g, "");
            const filename = `${fileStem}.wav`;

            if (action.onRenderComplete) {
              action.onRenderComplete(blob, filename);
            }
          };
        });
        break;
    }

    const result = next(action);
    return result;
  };
}
